import React, { LegacyRef } from 'react';
import Select from 'react-select';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LessonRateModel } from 'app/models/scheduling/LessonRateModel';
import { SelectStyles } from './constants';
import { CUSTOM_SESSION_OPTION } from './customSession';

type PropsDef = {
  control: any;
  name: string;
  options: LessonRateModel[];
  allowCustomSession: boolean;
  disabled?: boolean;
};

const SessionTypeSelector = React.forwardRef((props: PropsDef, _ref: LegacyRef<HTMLInputElement>) => {
  const { control, name, options, allowCustomSession, disabled = false } = props;
  const { field } = useController({ name, control });
  const { t } = useTranslation();

  const capitalizeFirst = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const getTranslatedTitle = (title: string) => {
    return capitalizeFirst(t(title));
  };

  const customOption = CUSTOM_SESSION_OPTION;

  let allOptions: any;
  if (allowCustomSession) {
    allOptions = [customOption, ...options];
  } else {
    allOptions = options;
  }

  return (
    <Select
      styles={SelectStyles}
      placeholder={capitalizeFirst(t('Select'))}
      getOptionLabel={opt => getTranslatedTitle(opt.title)}
      getOptionValue={opt => opt.id}
      options={allOptions}
      isSearchable={false}
      value={allOptions.find((option) => {
        return option.id === field.value;
      })}
      onChange={field.onChange}
      selected={field.value}
      isDisabled={disabled}
    />
  );
});

export default SessionTypeSelector;
